var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStraightLineType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6663 4.16667C16.6663 5.08714 15.9201 5.83333 14.9997 5.83333C14.826 5.83333 14.6585 5.80677 14.5011 5.75747L6.59048 13.6681C6.63977 13.8255 6.66634 13.993 6.66634 14.1667C6.66634 15.0871 5.92015 15.8333 4.99967 15.8333C4.0792 15.8333 3.33301 15.0871 3.33301 14.1667C3.33301 13.2462 4.0792 12.5 4.99967 12.5C5.28614 12.5 5.55573 12.5723 5.7912 12.6996L13.5326 4.95819C13.4053 4.72272 13.333 4.45314 13.333 4.16667C13.333 3.24619 14.0792 2.5 14.9997 2.5C15.9201 2.5 16.6663 3.24619 16.6663 4.16667Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraightLineType);
export default __webpack_public_path__ + "static/media/straight_line_type.2951b2b3161761ee5d60983b47b15d6b.svg";
export { ForwardRef as ReactComponent };